import { Component, Input, OnInit, Output, EventEmitter, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'ui-search-input-text',
  templateUrl: './search-input-text.component.html',
  styleUrls: ['./search-input-text.component.scss']
})
export class SearchInputTextComponent implements AfterViewChecked {

  /**
   * * Largura do componente.
   */
  width!: number;
  /**
   * * Altura do componente.
   */
  height!: number;

  /**
   * * Texto do hint (opcional).
   */
  @Input() public tooltipText: string = '';

  /**
   * * Texto do Placeholder do Componente.
   */
  @Input() public placeholderText!: string;

  /**
   * * Indica se o componente está desabilitado.
   */
  @Input() public disabled: boolean = false;

  /**
   * * Valor selecionado (que faz o campo se comportar como readonly).
   */
  @Input() selectedValue!: string;

  /**
   * * Mostrar o botão para limpar o campo.
   */
  @Input() showClearBtn: boolean = false;

  /**
   * * Evento acionado na ação de limpar valor do campo.
   */
  @Output() onclear = new EventEmitter<boolean>();

  /**
   * * Evento a ser chamado na alteração do campo de texto.
   */
  @Output() textChangeEvent = new EventEmitter<string>();

  private timer: any;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  onTextChange(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => this.emitChangeEvent(target.value), 150);
  }

  emitChangeEvent(value: string): void {
    this.textChangeEvent.emit(value);
  }

  onResized(event: ResizedEvent): void {
    this.width = (event as any).newWidth;
    // this.height = event.newHeight;

    if (this.width < 114) {
      this.input.placeholder = '';
    } else {
      this.input.placeholder = this.placeholderText !== undefined ?
      this.placeholderText : 'Pesquisar';
    }
  }

  get input(): any {
    return this.el.nativeElement.getElementsByTagName('input')[0];
  }

  get showClear(): boolean {
    return this.showClearBtn && (this.input?.value || this.selectedValue);
  }

  /**
   * * Método para limpar o campo de texto.
   */
  clear(): void {
    this.input.value = '';
    this.textChangeEvent.emit(this.input.value);
    this.onclear.emit(true);
  }
}
